export default __webpack_public_path__ + "static/media/sg-icon.46d8e940.webp";